import React, { Fragment, useEffect } from "react";
import { StyledTabsWrapper, StyledTabs } from "./styled";
import { useSetActive, useBuildTabs } from "./tabs-hooks";
export var Tabs = function (_a) {
    var className = _a.className, onChange = _a.onChange, selected = _a.selected, children = _a.children, _b = _a.TabsHeader, TabsHeader = _b === void 0 ? Fragment : _b, _c = _a.TabContent, TabContent = _c === void 0 ? Fragment : _c;
    var _d = useSetActive(selected, onChange), activeIndex = _d[0], setActiveIndex = _d[1];
    var _e = useBuildTabs(children, activeIndex, setActiveIndex), nav = _e[0], content = _e[1], firstActiveIndex = _e[2], activeIsDisabled = _e[3];
    useEffect(function () {
        if (activeIsDisabled && activeIndex !== firstActiveIndex)
            setActiveIndex(firstActiveIndex);
    }, [activeIndex, firstActiveIndex, activeIsDisabled, setActiveIndex]);
    return (React.createElement(StyledTabsWrapper, { className: className },
        React.createElement(TabsHeader, null,
            React.createElement(StyledTabs, { className: "tabs" }, nav)),
        React.createElement(TabContent, null, content)));
};
